import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getMaterialById } from "../../../api/materialService";
import { getErrorMessage } from "../../../utils/errorHandler"

export default function ViewMaterial() {
  const location = useLocation();
  const id = location?.state?.materialId;
  const [material, setMaterial] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchMaterial = async () => {
    try {
      setLoading(true);

      const response = await getMaterialById(id);

      setMaterial(response?.data || response);
    } catch (error) {
      console.error("Error fetching material:", error);
      alert(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchMaterial();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Loading...
          </div>
        </div>
      </div>
    );
  }

  if (!material) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-center py-4">
            Material not found
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-4">
        <div className="card p-3 d-flex justify-content-between">
          <h5 className="mb-1">View Material</h5>

          <div className="row g-3">
            <div className="col-md-4">
              <span className="fw-bold">Material Name : </span>
              
                {material.name}
            
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Material Value : </span>
                {material.value || "N/A"}
            </div>

            <div className="col-md-4">
              <span className="fw-bold">Status : </span>
                <span
                  className={`badge ${
                    material.status ? "bg-success" : "bg-danger"
                  }`}
                >
                  {material.status ? "Active" : "Inactive"}
                </span>
            </div>
          </div>
        </div>
    </div>
  );
}